import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, Button } from "../../../components/ui";

export default function AddOwnerModal({ isOpen, onClose, onSave, loading }) {
    const [formData, setFormData] = useState({
        owner_name: "",
        preferred_name: "",
        contact: "",
        email: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Add Property Owner</DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="owner_name" className="text-right text-xs font-bold text-[#374151]">
                            Name
                        </label>
                        <input
                            id="owner_name"
                            name="owner_name"
                            value={formData.owner_name}
                            onChange={handleChange}
                            placeholder="Full Name"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                            required
                        />
                    </div>
                    {/* The name this owner goes by, when it differs from their legal
                        name (Christian Gravias, Monday 12720874749). */}
                    <div className="grid grid-cols-4 items-start gap-4">
                        <label htmlFor="preferred_name" className="text-right text-xs font-bold text-[#374151] pt-2">
                            Preferred Name
                        </label>
                        <div className="col-span-3">
                            <input
                                id="preferred_name"
                                name="preferred_name"
                                value={formData.preferred_name}
                                onChange={handleChange}
                                placeholder="Andrew"
                                className="h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                            />
                            <p className="mt-1 text-[11px] text-gray-500">
                                Optional. The name they go by, if it differs from their legal name.
                            </p>
                        </div>
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="email" className="text-right text-xs font-bold text-[#374151]">
                            Email
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Email Address"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <label htmlFor="contact" className="text-right text-xs font-bold text-[#374151]">
                            Phone
                        </label>
                        <input
                            id="contact"
                            name="contact"
                            value={formData.contact}
                            onChange={handleChange}
                            placeholder="Phone Number"
                            className="col-span-3 h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
                        />
                    </div>
                    <DialogFooter>
                        <Button type="button" variant="outline" onClick={onClose} disabled={loading}>
                            Cancel
                        </Button>
                        <Button type="submit" className="bg-[#55C5D0] hover:bg-[#4AADB7] text-white" disabled={loading}>
                            {loading ? "Saving..." : "Save Owner"}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
